import type { FunctionComponent } from "react";
import DashboardSocialsAdminPartial from "../../../partials/admin/home/dashboard-socials.admin.partials";

export const SocialsAdminScreen: FunctionComponent = () => {
  return <DashboardSocialsAdminPartial />;
};
